<div class="user-card-container" ngbDropdown #profileDrop="ngbDropdown">
  <div class="user-card" id="userCard" ngbDropdownToggle role="link" aria-label="User Details">
    <a href="javascript:void(0)" title="User Details"><kendo-avatar [initials]="user.initials"></kendo-avatar></a>
    
  </div>
  <div ngbDropdownMenu aria-labelledby="userCard" role="menu">
    <div class="user-details">
      <h2>{{ user.fullName }}</h2>
      <p>{{user.companyName}}</p>
    </div>
    <div class="dd-menu-separator"></div>
    <div class="dd-menu-header">User Details</div>
    <button class="dd-menu-item" (click)="showProfileModal()" ngbDropdownItem role="menuitem">User Profile</button>
    <button class="dd-menu-item" (click)="showSettingsModal()" ngbDropdownItem role="menuitem">Settings</button>
    <div class="dd-menu-separator"></div>
    <button class="dd-menu-item" ngbDropdownItem (click)="logout()" role="menuitem">Log Out</button>
  </div>
</div>
